if (process.env.BUILD_GC === 'platform' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./platform')
} else {
  module.exports = null
}
